import { SessionInfo } from '@/interfaces/user';
import userServices from '@/api/userServices';
import { RootState } from '@/app/store';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

interface SessionState {
  currentSession: SessionInfo;
  otherSessions: SessionInfo[];
  loading: boolean;
  error: string;
}

const initialState: SessionState = {
  currentSession: {
    computerBrand: '',
    browser: '',
    location: '',
    date: '',
    ip: '',
  },
  otherSessions: [],
  loading: false,
  error: '',
};

export const fetchSessions = createAsyncThunk('sessions/fetch', async () => {
  return userServices.getSessions();
});

export const sessionSlice = createSlice({
  name: 'sessions',
  initialState,
  reducers: {
    refreshSessions: () => initialState,
    clearOtherSessions: state => {
      state.otherSessions = [];
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchSessions.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchSessions.fulfilled, (state, action) => {
      const { payload } = action;
      const currentSession = payload.current;
      state.currentSession = {
        computerBrand: currentSession.device.deviceType,
        browser: currentSession.device.browser,
        location: '',
        date: currentSession.createdAt,
        ip: currentSession.ipAddress,
      };
      state.otherSessions = normalizeSessions(payload.others);
      state.loading = false;
    });

    builder.addCase(fetchSessions.rejected, state => {
      state.loading = false;
      state.error = 'Error';
    });
  },
});

const normalizeSessions = (sessions: any): SessionInfo[] => {
  return sessions.map((session: any) => ({
    computerBrand: session.device.deviceType,
    browser: session.device.browser,
    location: '',
    date: session.createdAt,
    ip: session.ipAddress,
  }));
};

export const { refreshSessions, clearOtherSessions } = sessionSlice.actions;

export const selectSessions = (state: RootState) => state.sessions;

export default sessionSlice.reducer;
